module.exports = __webpack_public_path__ + "static/media/FiberousBroadRoot.c2450e68.PNG";